import React from 'react'
import ServiceNowBannerSection from '../../Components/mumbai/ServiceNowBannerSection'
import ServiceSection from '../../Components/mumbai/ServiceSection';
import ServiceNowConsultingSlider from '../../Components/mumbai/ServiceNowConsultingSlider';
import MaximizeModal from '../../Components/mumbai/MaximizeModal';
import IndustriesSliderSection from '../../Components/mumbai/IndustriesSliderSection';
import { Helmet } from 'react-helmet-async'
import HireDeveloper from '../../Components/hire/HireDeveloper';
import HeroServiceSection from '../../Components/mumbai/HeroServiceSection';
import LocationForm from '../../Components/mumbai/LocationForm';
import WhyChoose from '../../Components/mumbai/WhyChoose';
import EngagementModels from '../../Components/hire/EngagementModels';
import ServiceNowLeadForm from '../../Components/ServiceNowLeadForm';

const wellbeingData = [
    {
        id: 1,
        title: "Comprehensive Support",
        description: "Supporting businesses across Saudi Arabia with responsive assistance, trusted solutions, and continuous care to ensure long-term growth, operational excellence, and lasting success.",
        image: "/assets/mumbai/img2.png"
    },
    {
        id: 2,
        title: "Industry Expertise ",
        description: "Empowering businesses across Saudi Arabia with tailored digital solutions that drive innovation, efficiency, and sustainable growth across every industry.",
        image: "/assets/mumbai/img2.png"
    },
    {
        id: 3,
        title: "Customized Solutions",
        description: "Empowering businesses across Saudi Arabia with tailored digital solutions that streamline operations, achieve strategic goals, and drive sustainable long-term growth with confidence.",
        image: "/assets/mumbai/img2.png"
    },

];


const consultingData = [
    {
        id: 1,
        title: "ServiceNow Consulting",
        desc: "Strategic platform advisory, maturity assessments, and digital roadmap formulation tailored to optimize your ServiceNow enterprise landscape.",
        link: "/service/servicenow-consulting",
    },
    {
        id: 2,
        title: "ServiceNow Implementation",
        desc: "End-to-end multi-module deployment, configuration, and workflow automation executed with best practices for swift enterprise adoption.",
        link: "/service/servicenow-implementation",
    },
    {
        id: 3,
        title: "ServiceNow ITSM",
        desc: "Modernize service desk operations, incident triage, change management, and request fulfillment through intelligent IT service management.",
        link: "/service/servicenow-itsm",
    },
    {
        id: 4,
        title: "ServiceNow ITOM & CMDB",
        desc: "Gain real-time infrastructure visibility, build an accurate healthy CMDB, and automate event remediation with predictive discovery.",
        link: "/service/servicenow-itom-cmdb",
    },
    {
        id: 5,
        title: "ServiceNow CSM",
        desc: "Deliver connected customer experiences by breaking down silos across front, middle, and back-office teams with proactive issue resolution.",
        link: "/service/servicenow-csm",
    },
    {
        id: 6,
        title: "ServiceNow HRSD",
        desc: "Elevate employee experiences with streamlined onboarding, unified life-event journeys, and self-service HR service delivery portals.",
        link: "/service/servicenow-hrsd",
    },
    {
        id: 7,
        title: "ServiceNow AI & Automation",
        desc: "Leverage Generative AI, Now Assist, machine learning models, and virtual agents to automate complex multi-departmental workflows.",
        link: "/service/servicenow-ai-automation",
    },
    {
        id: 8,
        title: "ServiceNow Integration",
        desc: "Seamlessly integrate your ServiceNow instance with ERPs, CRMs, cloud platforms, and legacy systems via Integration Hub and custom APIs.",
        link: "/service/servicenow-integration",
    },
    {
        id: 9,
        title: "ServiceNow Custom Development",
        desc: "Build scalable, tailor-made applications and intuitive enterprise service portals using ServiceNow App Engine and UI Builder.",
        link: "/service/servicenow-custom-development",
    },
    {
        id: 10,
        title: "ServiceNow Managed Services",
        desc: "Continuous proactive support, performance monitoring, release upgrades, technical debt reduction, and platform governance.",
        link: "/service/servicenow-managed-services",
    },
    {
        id: 11,
        title: "ServiceNow Resource Augmentation",
        desc: "Scale your delivery bandwidth with certified ServiceNow architects, developers, technical consultants, and flexible dedicated pods.",
        link: "/service/servicenow-resource-augmentation",
    },
    {
        id: 12,
        title: "ServiceNow Center of Excellence (COE)",
        desc: "Build a scalable ServiceNow ecosystem with strong governance, platform standardization, continuous improvement, and enterprise-wide innovation.",
        link: "/service/servicenow-coe",
    },
];

const industriesData = [
    {
        id: 1,
        title: "Financial Services",
        desc: "At Mobikode, we empower financial businesses across Saudi Arabia with secure, innovative technology solutions that streamline operations, enhance customer experiences, and drive sustainable growth with confidence.",
        image: "/assets/mumbai/item1.png"
    },
    {
        id: 2,
        title: "eCommerce ",
        desc: "Mobikode helps eCommerce businesses across Saudi Arabia accelerate growth with secure, scalable, and innovative digital solutions that enhance customer experiences, streamline operations, and drive long-term business success.",
        image: "/assets/mumbai/item2.png"
    },
    {
        id: 3,
        title: "Insurance ",
        desc: "Helping Saudi Arabia's insurance providers streamline operations, enhance customer experiences, simplify claims and policy management, and achieve sustainable growth through secure, innovative, and reliable digital solutions.",
        image: "/assets/mumbai/item3.png"
    },
    {
        id: 4,
        title: "Manufacturing",
        desc: "At Mobikode, we empower Saudi Arabian manufacturers with smart digital solutions that streamline operations, boost productivity, optimize workflows, and drive sustainable growth through innovation and efficiency.",
        image: "/assets/mumbai/item4.png"
    },
    {
        id: 5,
        title: "Retail & Consumer Goods",
        desc: "Mobikode empowers retail and consumer businesses across Saudi Arabia with intelligent digital solutions that enhance customer experiences, streamline operations, boost efficiency, and accelerate sustainable business growth through innovation.",
        image: "/assets/mumbai/item5.png"
    },
    {
        id: 6,
        title: "Healthcare & Life Sciences",
        desc: "Mobikode helps healthcare and life sciences organizations across Saudi Arabia accelerate Enterprise AI & ServiceNow Consulting with intelligent technology solutions that enhance patient care, streamline operations, strengthen compliance, and deliver better health outcomes.",
        image: "/assets/mumbai/item6.png"
    },
    {
        id: 7,
        title: "Media & Communications ",
        desc: "Mobikode empowers media and communication businesses across Saudi Arabia with innovative digital solutions that enhance audience engagement, streamline operations, strengthen brand presence, and accelerate sustainable business growth through technology.",
        image: "/assets/mumbai/item7.png"
    },
    {
        id: 8,
        title: "Logistics & Transportation ",
        desc: "At Mobikode, we help logistics and transportation businesses across Saudi Arabia streamline operations, enhance delivery efficiency, and accelerate growth with reliable, innovative digital solutions tailored to industry needs.",
        image: "/assets/mumbai/item8.png"
    },
    {
        id: 9,
        title: "Technology",
        desc: "Mobikode helps businesses in Saudi Arabia transform ideas into powerful digital solutions through innovative technology, expert development, and tailored strategies that drive sustainable growth and success. ",
        image: "/assets/mumbai/item9.png"
    },
    {
        id: 10,
        title: "Non Profit",
        desc: "Mobikode helps non-profit organizations in Saudi Arabia embrace technology to simplify daily operations, reach more communities, inspire meaningful change, and maximize their positive social impact.",
        image: "/assets/mumbai/item10.png"
    },
    {
        id: 11,
        title: "Professional Services ",
        desc: "At Mobikode, we empower professional service businesses across Saudi Arabia with tailored digital solutions that streamline operations, embrace innovation, and deliver exceptional client experiences with confidence.",
        image: "/assets/mumbai/item11.png"
    },
    {
        id: 12,
        title: "Real Estate ",
        desc: "At Mobikode, we empower Saudi Arabia's real estate businesses with intelligent digital solutions that streamline operations, enhance customer experiences, and strengthen connections between developers, agents, and buyers.",
        image: "/assets/mumbai/item12.png"
    },

];

function SaudiArabia() {
    return (
        <div>
            <Helmet>
                <title>
                    ServiceNow Consulting in Saudi Arabia | Enterprise AI & ServiceNow Consulting | Mobikode
                </title>

                <meta
                    name="description"
                    content="Mobikode provides ServiceNow consulting in Saudi Arabia to modernize IT operations, automate business workflows, strengthen service management, and help organizations achieve efficient Enterprise AI & ServiceNow Consulting."
                />

                <meta
                    name="keywords"
                    content="ServiceNow Consulting Saudi Arabia, ServiceNow Consultant Saudi Arabia, ServiceNow ITSM Saudi Arabia, ServiceNow Enterprise AI & ServiceNow Consulting Saudi Arabia, ServiceNow Workflow Automation Saudi Arabia, ServiceNow Implementation Saudi Arabia, ServiceNow Integration Saudi Arabia, ServiceNow Managed Services Saudi Arabia, ServiceNow Development Saudi Arabia, ServiceNow Enterprise Solutions Saudi Arabia"
                />

                <link
                    rel="canonical"
                    href="https://www.mobikode.com/location/leverage-serviceNow-consulting-in-saudiarabia"
                />

                <meta
                    property="og:title"
                    content="ServiceNow Consulting in Saudi Arabia | Enterprise AI & ServiceNow Consulting | Mobikode"
                />

                <meta
                    property="og:description"
                    content="Transform IT and business operations with Mobikode's ServiceNow consulting services in Saudi Arabia. Automate workflows, improve service management, integrate enterprise systems, and build scalable digital operations."
                />

                <meta
                    property="og:url"
                    content="https://www.mobikode.com/location/leverage-serviceNow-consulting-in-saudiarabia"
                />

                <meta
                    property="og:type"
                    content="website"
                />

                <meta
                    property="og:image"
                    content="https://www.mobikode.com/assets/saudiarabia/bg1.png"
                />

                <meta
                    name="twitter:card"
                    content="summary_large_image"
                />

                <meta
                    name="twitter:title"
                    content="ServiceNow Consulting in Saudi Arabia | Mobikode"
                />

                <meta
                    name="twitter:description"
                    content="Discover scalable ServiceNow solutions in Saudi Arabia for ITSM, workflow automation, enterprise integration, and Enterprise AI & ServiceNow Consulting with Mobikode."
                />

                <meta
                    name="twitter:image"
                    content="https://www.mobikode.com/assets/saudiarabia/bg1.png"
                />
            </Helmet>
            <HeroServiceSection bgImage="/assets/mumbai/bg1.png" title="Leverage ServiceNow Consulting in SaudiArabia" description="Partner with Mobikode’s ServiceNow experts in SaudiArabia to simplify daily operations, empower your teams, automate business processes, and achieve sustainable growth through intelligent Enterprise AI & ServiceNow Consulting. Trusted by Startups and Leading Companies Worldwide" />
            <ServiceNowLeadForm bgImage="/assets/mumbai/SaudiArabia.png" />
            <ServiceNowConsultingSlider consultingData={consultingData} />
            <WhyChoose />
            <MaximizeModal wellbeingData={wellbeingData} />
            <EngagementModels />
            <IndustriesSliderSection industriesData={industriesData} />
            {/* <section className="relative w-full h-[500px] lg:h-[630px] flex items-center bg-[#000814] overflow-hidden py-12 md:py-0">
                <div className="absolute inset-0 z-0">
                    <img
                        src="/assets/mumbai/bg1.png"
                        alt="Abstract 3D Background"
                        className="w-full h-full object-cover"
                    />
                    <div
                        style={{ background: "linear-gradient(86.84deg, #000000 20%, rgba(0, 0, 0, 0) 79%)" }}
                        className="hidden md:block absolute inset-0"
                    ></div>
                    <div
                        style={{ background: "linear-gradient(0deg, #000000 40%, rgba(0, 0, 0, 0.3) 100%)" }}
                        className="block md:hidden absolute inset-0"
                    ></div>
                </div>

                <div className="relative z-10 w-full max-w-[1440px] mx-auto px-[20px] md:px-[40px] lg:px-[80px] flex flex-col items-start justify-center h-full">
                    <div className="w-full max-w-[500px] md:max-w-[700px] lg:max-w-[900px] mt-auto md:mt-0">
                        <h1 className="text-white font-[600] text-[28px] sm:text-[36px] md:text-[50px] lg:text-[60px] font-sora leading-[1.2] lg:leading-[1.1] mb-[12px] lg:mb-[22px] drop-shadow-xl tracking-wide text-left">
                            Leverage ServiceNow Consulting in Saudi Arabia
                        </h1>
                        <p className="text-[#FFFFFF] max-w-[800px] w-full text-[14px] sm:text-[16px] md:text-[18px] leading-[20px] md:leading-[22px] lg:leading-[24px] font-graphik font-light tracking-wider text-left opacity-90 lg:opacity-100">
                            Empower your business in Saudi Arabia with Mobikode's ServiceNow experts to streamline operations, boost productivity, automate workflows, and accelerate sustainable growth.
                        </p>
                    </div>
                </div>
            </section> */}
            {/* <ServiceSection image={"/assets/mumbai/SaudiArabia.png"}
                text={"At Mobikode, we help businesses across Saudi Arabia unlock the full potential of ServiceNow with tailored consulting, seamless implementation, and smart automation. Our experts simplify workflows, integrate business systems, and enhance user experiences, enabling organizations to improve efficiency, accelerate Enterprise AI & ServiceNow Consulting, and achieve sustainable growth with scalable, future-ready ServiceNow solutions."}
                title={"ServiceNow Consulting"} />
            <ServiceNowConsultingSlider consultingData={consultingData} />
            <MaximizeModal wellbeingData={wellbeingData} />
            <IndustriesSliderSection industriesData={industriesData} />
            <ServiceNowBannerSection imgs={"/assets/mumbai/img3.png"}
                title="ServiceNow Consulting Services"
                text="At Mobikode, we empower businesses across Saudi Arabia with tailored ServiceNow consulting, intelligent automation, and seamless digital solutions that streamline operations, boost efficiency, and enhance customer experiences." />
            <HireDeveloper /> */}
        </div>
    )
}

export default SaudiArabia
